<div class="stp__tabs">
    <segment-control class="stp__picker--tabs"
                     [options]="tabs"
                     [selected]="currentTab"
                     (select)="onTabChange($event)"></segment-control>
</div>
<div class="stp__content">
    <ng-container [ngSwitch]="currentTab.value">
        <ng-container *ngSwitchCase="EStatisticsTab.AllBets">
            <div class="stp__container--total-bets">
                <p>{{'TOTAL_BETS' | translate}}: <span>{{totalBets}}</span></p>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="EStatisticsTab.TopBets">
            <div class="stp__container--timespan">
                <custom-select class="stp__select--timespan"
                               [selected]="topBetsTimespanValue" [options]="topBetsTimespanOptions"
                               (select)="onTopBetsTimespanValueChange($event)"></custom-select>
            </div>
        </ng-container>
    </ng-container>
    <statistics-container class="stp__statistics-container" [ngClass]="currentTab.value" [statisticsLabels]="labels"
                          [category]="currentTab.value">
        <statistics-list-item class="stp__statistics-item dummy" #dummyStatItem></statistics-list-item>
        <paginate-items-container class="stp__virual-scroll"
                                  [itemsDataList]="statisticsList"
                                  [virtualScroll]="true"
                                  [templateRef]="statItemTemplate"
                                  [loaderOn]="loaderOn"
                                  [itemSize]="dummyStatItem.element.nativeElement.offsetHeight"
                                  [scrolledToBottom]="requestNewBetsPageUseCase">
        </paginate-items-container>
    </statistics-container>
</div>
<ng-template #statItemTemplate let-data>
    <statistics-list-item class="stp__statistics-item" [statisticsListItemConfig]="data"></statistics-list-item>
</ng-template>
